import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App'
// Initialize Google Analytics with Consent Mode v2 BEFORE React renders
// This ensures Tag Assistant can detect the tag immediately
;
(function initializeGoogleAnalytics() {
  const GA_MEASUREMENT_ID = 'G-G2KMYSEDB3';
  console.log('[Analytics] Initializing Google Analytics with Consent Mode v2');
  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer?.push(arguments);
  }
  window.gtag = gtag;
  // Set default consent to denied (Consent Mode v2 - MUST be before gtag.js loads)
  console.log('[Analytics] Setting default consent to denied');
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });
  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.onload = () => {
    console.log('[Analytics] gtag.js loaded successfully');
  };
  script.onerror = () => {
    console.error('[Analytics] Failed to load gtag.js');
  };
  document.head.appendChild(script);
  // Initialize gtag
  gtag('js', new Date());
  // Configure GA4 (but don't send pageviews yet - wait for consent)
  console.log('[Analytics] Configuring GA4 tag:', GA_MEASUREMENT_ID);
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure'
  });
  console.log('[Analytics] Google Analytics initialized. Waiting for user consent.');
})();
render(<App data-id="element-72" />, document.getElementById('root'));